import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PILOT_QUALIFICATIONS } from "@/data/content";

export const PilotProgram = () => (
  <section id="pilot" data-testid="pilot-program-section" className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[48px]">
    <div
      data-testid="pilot-program-panel"
      className="lg:mx-auto lg:max-w-[1280px] rounded-3xl bg-glacier px-6 py-10 sm:px-10 sm:py-12 lg:px-[68px] lg:py-[60px]"
    >
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55 }}
          className="lg:col-span-7"
        >
          <span data-testid="pilot-program-eyebrow" className="text-sm font-medium text-teal">PILOT PROGRAM</span>
          <h2 className="mt-3 max-w-xl font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:text-[41px]">
            Become an early demonstration farm
          </h2>
          <p className="mt-5 max-w-lg lg:max-w-[520px] text-[15px] leading-relaxed text-inkSoft">
            We are looking for British Columbia agricultural operations where grid constraints,
            diesel dependence, expansion requirements or long-duration backup needs create a
            strong case for hybrid energy.
          </p>

          <Link
            to="/pilot"
            data-testid="pilot-program-cta"
            className="mt-9 flex w-full justify-start items-center gap-2 bg-teal text-white text-sm font-medium rounded-full px-6 py-3 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5 lg:inline-flex lg:w-auto lg:h-10 lg:py-0"
          >
            Apply for a Pilot Energy Assessment
            <ArrowRight size={14} className="hidden lg:block" />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, delay: 0.1 }}
          className="-mt-[5px] lg:col-span-5 lg:mt-0 lg:border-l lg:border-borderSubtle lg:pl-16"
        >
          <span className="font-heading text-lg font-semibold text-ink">A strong pilot candidate may have:</span>
          <div data-testid="pilot-qualifications" className="mt-6 space-y-3.5">
            {PILOT_QUALIFICATIONS.map((item, index) => (
              <div key={item} data-testid={`pilot-qualification-${index}`} className="flex items-baseline gap-3">
                <span aria-hidden="true" className="text-sm text-inkMuted shrink-0">
                  —
                </span>
                <span className="text-[15px] text-inkSoft">{item}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-inkMuted">For British Columbia agricultural operations.</p>
        </motion.div>
      </div>
    </div>
  </section>
);
